<template>
  <div>
    <v-select
      v-model="inputedValue"
      item-text="label"
      item-value="value"
      :items="items"
      dense
      outlined
      return-object
      class="original-selectbox"
      hide-details
      :placeholder="$t('common.input_unselected_2')"
      :height="height"
      width="80%"
      clearable
    >
    </v-select>
  </div>
</template>

<script>
import { orderUtil } from '@/util'
import { orderStatusHistory } from '@/config'

export default {
  components: {
    //
  },
  props: {
    value: {},
    type: Number,
    height: { default: '32px' }
  },
  data: () => ({
    items: []
    // test: {}
  }),
  created() {
    const status = orderStatusHistory.STATUS_HISTORY_TYPE_ID
    const statusUtil = orderUtil

    let tmp
    if (this.type === status.WITHDRAW) {
      tmp = statusUtil.getOrderWithdrawStatusList()
    } else if (this.type === status.LOADING) {
      tmp = statusUtil.getOrderLoadingStatusList()
    } else if (this.type === status.COMPLETE) {
      tmp = statusUtil.getOrderCompleteStatusList()
    } else if (this.type === status.REGISTER) {
      tmp = statusUtil.getOrderRegisterStatusList()
    }
    tmp.map((ele) => {
      this.items.push(ele)
    })
  },
  computed: {
    inputedValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('changeValue', newValue)
        this.$emit('input', newValue)
      }
    }
  }
}
</script>
<style scoped lang="scss"></style>
